/** @prettier */
import { TestReviewDispatch } from "./testReviewState";
import { useEffect } from "react";

const useTestReviewKeyboardShortcuts = (dispatch: TestReviewDispatch) => {
    useEffect(() => {
        // event.key is the logical key, event.code is the physical
        const handler = ({ key }: KeyboardEvent) => {
            switch (key) {
                case "ArrowDown":
                case "ArrowRight":
                    return dispatch({ event: "selectQuestion", index: "next" });
                case "ArrowUp":
                case "ArrowLeft":
                    return dispatch({ event: "selectQuestion", index: "prev" });
            }
        };
        window.addEventListener("keyup", handler);
        return () => window.removeEventListener("keyup", handler);
    }, [dispatch]);
};
export default useTestReviewKeyboardShortcuts;
